import { DetailWrapper } from "../../../../../features/ui"
import { CreditCardDetail } from "./creditCardDetail"

export const CreditCardDetailLoader = () => (
    <DetailWrapper>
        <CreditCardDetail />
    </DetailWrapper>
)
